import i18n from 'i18next';
import { toast } from 'react-hot-toast';


export function validatePassword(password, confPassword) {
	const errorList = []
	if (password.length < 8 || password.length > 100)
		errorList.push(i18n.t('Login:Must contain at least 8 characters'))
	if (!/(?=.*[a-z])/.test(password))
		errorList.push(i18n.t('Login:Must contain at least one lowercase letter'))
	if (!/(?=.*[A-Z])/.test(password))
		errorList.push(i18n.t('Login:Must contain at least one uppercase letter'))
	if (!/(?=.*\d)/.test(password))
		errorList.push(i18n.t('Login:Must contain at least one number'))
	if (!/(?=.*[-+_!@#$%^&*.,?])/.test(password))
		errorList.push(
			i18n.t('Login:Must contain at least one special character')
		)
	if (!(password === confPassword))
		errorList.push(i18n.t('Login:Must match'))

	if (errorList.length > 0) {
		errorList.forEach((error) => toast.error(error))
		return false
	}

	return true
}


export function escapeText(text) {
	let textEscaped = text.replace(/\\'/g, '%');
    textEscaped = unescape(textEscaped);
	textEscaped = textEscaped.replace(/\\/g, '');
	return textEscaped
}
